/**
 * CWR 2.5 — pure helpers for the booking-form sheet header (D3) and the
 * payment-aware bottom CTA label (F). DetailsPage owns the label; FormRenderer
 * relocates the button into the floating bar via the renderActions slot.
 */

/**
 * The sheet header's "<type> · Required to …" line. Booking forms are only ever
 * REGISTRATION / INTAKE / WAIVER (GENERAL is non-assignable to offerings, §3-D);
 * any other value falls back to the neutral "Form · Required to book".
 */
export function formTypeLine(formType: string): string {
  switch (formType) {
    case 'REGISTRATION':
      return 'Registration · Required to book';
    case 'INTAKE':
      return 'Intake form · Required to book';
    case 'WAIVER':
      return 'Waiver · Required to sign';
    default:
      return 'Form · Required to book';
  }
}

export interface CtaLabelInput {
  formType: string;
  /** This is the last form before the flow advances out of the forms phase. */
  isLastForm: boolean;
  /** A PAYMENT step exists ahead in progressSteps. */
  hasPaymentAhead: boolean;
  /** All required fields on the current form validate. */
  formReady: boolean;
}

/**
 * Payment-aware CTA copy:
 *  - REGISTRATION before its required fields validate → "Complete Registration"
 *    (the grounded special copy; flips to "Continue" once ready).
 *  - the last form with a payment step ahead → "Continue to payment".
 *  - otherwise → "Continue".
 */
export function ctaLabel({ formType, isLastForm, hasPaymentAhead, formReady }: CtaLabelInput): string {
  if (formType === 'REGISTRATION' && !formReady) return 'Complete Registration';
  if (isLastForm && hasPaymentAhead) return 'Continue to payment';
  return 'Continue';
}
